/**
 * Shopify Referrer & UTM Tracker
 *
 * This script captures traffic source data when a visitor lands on your store
 * and stores it in sessionStorage for later attachment to the order.
 *
 * Captured data:
 * - HTTP Referrer
 * - UTM parameters (source, medium, campaign, content, term)
 * - Landing page URL
 *
 * Installation: Add this script to your theme.liquid file before </head>
 */

(function() {
  'use strict';

  // Storage key for tracking data
  var STORAGE_KEY = 'shopify_referrer_data';

  /**
   * Get URL parameter value
   */
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  /**
   * Check if tracking data already exists in session
   */
  function hasExistingData() {
    try {
      var existing = sessionStorage.getItem(STORAGE_KEY);
      return existing !== null;
    } catch (e) {
      console.error('sessionStorage access error:', e);
      return false;
    }
  }

  /**
   * Capture and store referrer data
   */
  function captureReferrerData() {
    // Only capture on first page view in session
    if (hasExistingData()) {
      console.log('Referrer data already captured in this session');
      return;
    }

    var data = {
      referrer: document.referrer || '',
      utm_source: getUrlParameter('utm_source'),
      utm_medium: getUrlParameter('utm_medium'),
      utm_campaign: getUrlParameter('utm_campaign'),
      utm_content: getUrlParameter('utm_content'),
      utm_term: getUrlParameter('utm_term'),
      landing_page: window.location.href,
      captured_at: new Date().toISOString()
    };

    // Only store if we have some data
    var hasData = data.referrer ||
                  data.utm_source ||
                  data.utm_medium ||
                  data.utm_campaign;

    if (hasData) {
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        console.log('Referrer data captured:', data);
      } catch (e) {
        console.error('Failed to store referrer data:', e);
      }
    } else {
      console.log('No referrer or UTM data to capture');
    }
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', captureReferrerData);
  } else {
    captureReferrerData();
  }
})();
